export default "__VITE_ASSET__217748b3__"